export function checkJson(str) {
    try {
        return JSON.parse(str);
    } catch (e) {
        console.error(e);
        return false;
    }
}